var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-radio-group',{class:{ ..._vm.selectClass, 'radio-btn-group': true },attrs:{"id":_vm.id,"options":_vm.options,"multiple":_vm.multiple,"checked":_vm.value,"disabled":_vm.disabled,"button-variant":"gray","buttons":""},on:{"input":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }